export default "__VITE_PUBLIC_ASSET__bf6811b1__"